export const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export const downloadName = (story, region) => `HSA Tax Savings – ${story.name} – ${region}.pdf`;

export const buildStoryCatalog = ({ regions, stories, files, industries = [] }) => {
    const fileFor = (storyId, region) => files.find((f) => f.story === storyId && f.region === region);
    const storiesFor = (region, industry = "all") =>
        stories.filter((s) => fileFor(s.id, region) && (industry === "all" || s.group === industry));
    const industriesFor = (region) => {
        const groups = new Set(storiesFor(region).map((s) => s.group));
        return industries.filter((g) => groups.has(g.id));
    };
    const availableRegions = regions.filter((r) => files.some((f) => f.region === r));
    const storyCount = stories.filter((s) => files.some((f) => f.story === s.id)).length;
    const regionPart = plural(availableRegions.length, "REGION", "REGIONS");

    return {
        regions: availableRegions,
        defaultRegion: availableRegions.includes("Western") ? "Western" : availableRegions[0],
        storiesFor,
        fileFor,
        industriesFor,
        rosterFor: (region, industry = "all") =>
            stories
                .filter((s) => files.some((f) => f.story === s.id) && (industry === "all" || s.group === industry))
                .map((s) => ({
                    ...s,
                    available: Boolean(fileFor(s.id, region)),
                    regions: regions.filter((r) => fileFor(s.id, r)),
                })),
        resolveStory: (storyId, region, industry = "all") => {
            const listed = storiesFor(region, industry);
            return listed.some((s) => s.id === storyId) ? storyId : listed[0]?.id;
        },
        resolveIndustry: (industry, region) =>
            industry === "all" || industriesFor(region).some((g) => g.id === industry) ? industry : "all",
        storyCount,
        badge: storyCount > 1 ? `${plural(storyCount, "STORY", "STORIES")} · ${regionPart}` : regionPart,
    };
};
